import { useLayoutEffect, useRef, useState } from "react";

export function companionFits(available: number, content: number, companion: number, spacing: number) {
  return available > 0 && companion > 0 && content + companion + spacing <= available;
}

export function useCompanionSpace(eligible: boolean) {
  const stageRef = useRef<HTMLDivElement>(null);
  const companionRef = useRef<HTMLDivElement>(null);
  const spacerRef = useRef<HTMLDivElement>(null);
  const [fits, setFits] = useState(false);
  useLayoutEffect(() => {
    const stage = stageRef.current;
    const companion = companionRef.current;
    const spacer = spacerRef.current;
    const nutrition = stage?.querySelector<HTMLElement>(".nutrition-result");
    if (!eligible || !stage || !companion || !nutrition || !spacer) return;
    const measure = () => {
      const spacing = parseFloat(getComputedStyle(companion).marginTop) + parseFloat(getComputedStyle(spacer).minHeight) + 2;
      setFits(companionFits(stage.clientHeight, nutrition.scrollHeight, companion.offsetHeight, spacing));
    };
    measure();
    const observer = new ResizeObserver(measure);
    // The stage has a fixed share of the screen. The hidden companion keeps its
    // measurable size, so hiding it cannot itself trigger a show/hide loop.
    [stage, companion, nutrition, ...nutrition.children].forEach(element => observer.observe(element));
    return () => observer.disconnect();
  }, [eligible]);
  return { stageRef, companionRef, spacerRef, showCompanion: eligible && fits };
}
